import iconBusiness from "../assets/images/icon-business.svg";
import iconPersonal from "../assets/images/icon-personal.svg";

export default {
  iconBusiness,
  iconPersonal,
};
